const FEATURE_FLAGS = {
  feature_flag_activities: true,
};

export default FEATURE_FLAGS;
